import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_DIVIDEND_PAYOUTS } from "../../../config/api";

export const getStockDividendPayouts = createAsyncThunk(
  "stocks/dividendPayouts",
  async (arg = {}, { rejectWithValue }) => {
    const { id, ...queryParams } = arg || {};
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_DIVIDEND_PAYOUTS(id),
        queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
